import { useEffect } from "react";
import "@fontsource/cormorant-garamond/400.css";
import "@fontsource/cormorant-garamond/500.css";
import "@fontsource/cormorant-garamond/600.css";
import "@fontsource/cormorant-garamond/400-italic.css";
import "@fontsource/cormorant-garamond/500-italic.css";
import "@fontsource/plus-jakarta-sans/400.css";
import "@fontsource/plus-jakarta-sans/500.css";
import "@fontsource/jetbrains-mono/400.css";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import Lenis from "lenis";
import { LangProvider } from "./i18n/LangContext";
import { Preloader } from "./components/site/Preloader";
import { CookieNotice } from "./components/site/CookieNotice";
import Privacy from "./pages/Privacy";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/site/Header";
import { Footer } from "./components/site/Footer";
import Home from "./pages/Home";
import ChiSiamo from "./pages/ChiSiamo";
import CosaFacciamo from "./pages/CosaFacciamo";
import Progetti from "./pages/Progetti";
import Contatti from "./pages/Contatti";

let lenis = null;

const SmoothScroll = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); lenis = null; };
  }, []);
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const PageFade = ({ children }) => {
  const { pathname } = useLocation();
  return (
    <motion.div key={pathname} initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}>
      {children}
    </motion.div>
  );
};

function App() {
  return (
    <div className="App grain">
      <LangProvider>
      <BrowserRouter>
        <Preloader />
        <SmoothScroll />
        <Header />
        <PageFade>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/chi-siamo" element={<ChiSiamo />} />
          <Route path="/cosa-facciamo" element={<CosaFacciamo />} />
          <Route path="/progetti" element={<Progetti />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="*" element={<Home />} />
        </Routes>
        </PageFade>
        <Footer />
        <CookieNotice />
        <Toaster position="bottom-center" />
      </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
